import React, { useContext } from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import tinycolor from 'tinycolor2';
import { forwardInnerRef } from 'localmed-core';

import Link, { LinkProps } from '../Link';

import { AlertContext, AlertType } from './Alert';
import { ThemeProps } from '../../../../types';

export type Props = LinkProps;

type StyleProps = ThemeProps & {
  tier: AlertType;
  subtle: boolean;
};

export function getHoverBackgroundColor({ tier, subtle, theme }: StyleProps) {
  if (!subtle) return 'rgba(0, 0, 0, 0.15)';

  const backgroundColor: any = tier ? theme.colors[tier] || theme.colors.info : theme.colors.info;
  return tinycolor(backgroundColor).setAlpha(0.1).toString();
}

const StyledAlertLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'tier' && prop !== 'subtle',
})(
  (props: StyleProps) => css`
    label: base;
    color: currentColor;
    border-bottom: 1px solid;

    &:focus,
    &:hover {
      background: ${getHoverBackgroundColor(props)};
      color: ${props.subtle ? props.theme.colors.heading : 'currentColor'};
    }
  `
);

function AlertLink({ innerRef, ...props }: Props) {
  const alertValues = useContext(AlertContext);
  return <StyledAlertLink ref={innerRef} {...props} {...alertValues} />;
}

export default forwardInnerRef<Props, void>(AlertLink);
